import { apolloClient } from '~/apollo-client';
import { FETCH_PERCH_CONSENT } from './fetch-perch-consent.queries';

type ConsentVersion = {
  id: number;
  displayName?: string | null;
  internalName?: string | null;
  contractType?: string | null;
  notes?: string | null;
  fileUrl?: string | null;
};

export interface FetchPerchConsentParams {
  signupContractTemplateId: number;
}

export interface FetchPerchConsentResponse {
  signupContractTemplateContractVersions: ConsentVersion[];
}

export const fetchPerchConsent = async (
  params: FetchPerchConsentParams,
): Promise<FetchPerchConsentResponse> => {
  const { data } = await apolloClient.query<FetchPerchConsentResponse, FetchPerchConsentParams>({
    query: FETCH_PERCH_CONSENT,
    variables: { signupContractTemplateId: params.signupContractTemplateId },
  });

  return data;
};
